import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './JoinPartyPage.css';

function JoinPartyPage({ API_URL }) {
  const navigate = useNavigate();
  const [partyCode, setPartyCode] = useState('');
  const [playerName, setPlayerName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Check the code param and update the partyCode state
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (code) {
      setPartyCode(code);
    }
  }, []);

  const handleSubmit = async (e) => {
    // Check if user is already hosting a party
    // const isCurrentlyHost = localStorage.getItem('isHost') === 'true';
    // if (isCurrentlyHost) {
    //   const confirmJoin = window.confirm(
    //     'You are currently hosting another party. Joining a new party will remove your host status. ' +
    //     'For testing, please use a different browser or incognito mode for different players. ' +
    //     '\n\nDo you want to continue?'
    //   );
    //   if (!confirmJoin) {
    //     return;
    //   }
    // }
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/parties/${partyCode}/join`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          playerName: playerName
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Joined party:', data);

      // Store player info in localStorage
      localStorage.setItem('partyCode', partyCode);
      localStorage.setItem('playerId', data.playerId);
      localStorage.setItem('playerName', playerName);
      // localStorage.setItem('isHost', 'false');

      // Navigate to lobby
      navigate(`/lobby/${partyCode}`);
    } catch (err) {
      console.error('Error joining party:', err);
      setError('Failed to join party. Please check the code and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const formatPartyCode = (code) => {
    // Remove non-alphanumeric characters and convert to uppercase
    const formatted = code.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    // Limit to 6 characters
    return formatted.slice(0, 6);
  };

  return (
    <div className="join-party-container">
      <div className="join-party-card">
        <Link to="/" className="back-button">
          <span className="back-arrow">←</span>
          Back to Home
        </Link>
        
        <h1 className="title">Join a Party</h1>
        <p className="subtitle">Enter the party code to join the fun!</p>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="partyCode" className="input-label">
              Party Code
            </label>
            <input
              type="text"
              id="partyCode"
              className="input-field"
              value={partyCode}
              onChange={(e) => setPartyCode(formatPartyCode(e.target.value))}
              placeholder="Enter 6-digit code"
              maxLength={6}
              required
            />
            <p className="help-text">
              Ask your friend for the 6-digit party code
            </p>
          </div>

          <div className="input-group">
            <label htmlFor="playerName" className="input-label">
              Your Name
            </label>
            <input
              type="text"
              id="playerName"
              className="input-field"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              placeholder="Enter your name"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="join-button"
            disabled={isLoading || !partyCode || !playerName}
          >
            {isLoading ? 'Joining...' : 'Join Party'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default JoinPartyPage;
